import buildFilteringSettingsFromCandidate from './buildFilteringSettingsFromCandidate.js';
import buildOperatorOptionsFromCandidate from './buildOperatorOptionsFromCandidate.js';
import getFieldPathState from './getFieldPathState.js';
import getFilterArgCandidates from './getFilterArgCandidates.js';
import getGraphqlLeafFieldNames from './getGraphqlLeafFieldNames.js';
import getPathSegments from './getPathSegments.js';

const getGraphqlFilterIntrospection = (schema, { graphqlRoot, preferredArgName, segmentPath } = {}) => {
  if (!schema || !graphqlRoot) {
    return null;
  }

  const leafFieldNames = new Set(getGraphqlLeafFieldNames(schema, graphqlRoot));

  if (!leafFieldNames.size) {
    return null;
  }

  const rootSegments = getPathSegments(graphqlRoot);
  const targetPath = segmentPath || rootSegments[0];
  const targetFieldPathState = getFieldPathState(schema, targetPath);
  const targetField = targetFieldPathState?.traversedFields?.[targetFieldPathState.traversedFields.length - 1];

  if (!targetField) {
    return null;
  }

  const candidate = getFilterArgCandidates({ targetField, leafFieldNames, preferredArgName })[0];

  if (!candidate) {
    return {
      fieldNames: [...leafFieldNames],
      filteringSettings: null,
      operatorOptions: []
    };
  }

  const matchedFieldNames = [...candidate.analysis.fieldOperators.keys()];
  const fieldNames = matchedFieldNames.length > 0 ? matchedFieldNames.filter((fieldName) => leafFieldNames.has(fieldName)) : [...leafFieldNames];

  return {
    fieldNames: fieldNames.length > 0 ? fieldNames : [...leafFieldNames],
    filteringSettings: buildFilteringSettingsFromCandidate(candidate),
    operatorOptions: buildOperatorOptionsFromCandidate(candidate)
  };
};

export default getGraphqlFilterIntrospection;
